import { z } from 'zod';

export const querySchema = z.object({
  mediaId: z.string().default(''),
});
